import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _CopyLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M14 7c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C12.398 4 11.932 4 11 4H8c-1.886 0-2.828 0-3.414.586S4 6.114 4 8v3c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C5.602 14 6.068 14 7 14" }),
            React.createElement("rect", { width: 10, height: 10, x: 10, y: 10, stroke: "currentColor", rx: 2 })));
}
const CopyLight = forwardRef(_CopyLight);
export { CopyLight };
